import { Fragment, type FunctionComponent } from "react";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";
import { tracking } from "shared/data";
import { useCurrentPageType } from "shared/hooks";

import { MenuItemAccordionList } from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-menu-item/accordion-list";
import { MenuItemHighlight } from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-menu-item/highlight";
import { MenuItemTopic } from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-menu-item/topics";
import type { BurgerMenuTopTab } from "scmp-app/lib/app/hooks/scmp-pwa-burger-menu-config";
import { useScmpPwaBurgerMenuConfig } from "scmp-app/lib/app/hooks/scmp-pwa-burger-menu-config";

import { useBurgerMenuTopics } from "./hooks";
import { Container } from "./styles";

type Props = {
  className?: string;
};

export const HamburgerMenuList: FunctionComponent<Props> = ({ className }) => {
  const { scmpPwaBurgerMenuConfigState } = useScmpPwaBurgerMenuConfig();
  const tobTab = scmpPwaBurgerMenuConfigState.result?.topTab as BurgerMenuTopTab;
  const tabs = scmpPwaBurgerMenuConfigState.result?.tabs as BurgerMenuTopTab[];
  const topics = useBurgerMenuTopics();
  const pageType = useCurrentPageType();

  const renderMenuItem = (items: BurgerMenuTopTab) => {
    if (items) {
      switch (items.type) {
        case "accordion-list":
          return (
            <MenuItemAccordionList
              items={items.items}
              label={items?.button?.text}
              type={items.type}
            />
          );
        case "highlight":
          return <MenuItemHighlight items={items.items} />;
        case "topics":
          return <MenuItemTopic label={items?.button?.text} reference={topics} type={items.type} />;
      }
    }
  };
  return (
    <Container className={className}>
      <BaseLinkContextProvider
        customQueryParameters={{
          module: tracking.module.HamburgerMenu,
          pgtype: pageType,
        }}
      >
        {renderMenuItem(tobTab)}
        {tabs?.map((tab, index) => (
          <Fragment key={index}>{renderMenuItem(tab)}</Fragment>
        ))}
      </BaseLinkContextProvider>
    </Container>
  );
};
